import styles from "./SuppliesItem.module.css";
import { Link } from "react-router-dom";

function SuppliesItem({ image, altImage, titulo, to }) {
  return (
    <Link to={to} className={styles.item_container}>
      <div className={styles.circle_fill}></div>
      <div className={styles.circle_border}></div>
      <img src={image} alt={altImage} className={styles.image_overlay} />
      <h2>{titulo}</h2>
    </Link>
  );
}

export default SuppliesItem;
